import { mainApi } from "../../../../api";

const key = "sessionTheory";

export const aiSessionTheoryQuery = (sessionId: string) => ({
    queryKey: [key, sessionId],
    queryFn: async () => mainApi.get(`get_session_theory/${sessionId}`),
});
